"use client";
import React, { memo } from "react";
import InputSearchV2 from "@onair/ui/form-controls/input-search-v2";
import { useSearchPostsStore } from "../../hooks/use-category-filter";
import { cn } from "@onair/utils/cn";
interface SearchFieldProps {
	className?: string;
}
const SearchField: React.FC<SearchFieldProps> = ({ className }) => {
	const [textSearch, setSearch] = useSearchPostsStore((state) => [
		state.textSearch,
		state.onSearch,
	]);
	return (
		<div className={cn("search-field", className)}>
			<InputSearchV2
				value={textSearch}
				placeholder="Nhập nội dung tìm kiếm"
				className="rounded-xl border"
				onSearch={setSearch}
			/>
		</div>
	);
};
export default memo(SearchField);
